import { render, staticRenderFns } from "./KnFormReportCardDesign.vue?vue&type=template&id=15054340"
import script from "./KnFormReportCardDesign.js?vue&type=script&lang=js&external"
export * from "./KnFormReportCardDesign.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports